// External Imports
import get from 'lodash/fp/get.js';
import set from 'lodash/fp/set.js';

// Internal Imports
import { contentRelationMap } from '../config/types/content/relations.mjs';
import { createGetContentItem, getItemById } from './createGetContentItem.mjs';
import { getMatch } from './getMatch.mjs';

// Local Functions
const getRelatedContentItemsByItem = (state, item) =>
  getRelatedContentItems(state, contentRelationMap, {
    metadata: get('metadata', item),
    type: get('metadata.type', item),
  });

const getPostRelationsMap = (relationMap, match, data) => {
  const pathType = get('pathType', match);
  const contentType = data.type;

  return relationMap[contentType] || relationMap[pathType];
};

function getRelatedContentItems(state, relationMap, data) {
  let related = {};
  if (!data) {
    return related;
  }

  const relations = getPostRelationsMap(relationMap, getMatch(state), data);
  if (!relations) {
    return related;
  }

  for (const path of Object.keys(relations)) {
    const { path: setPath, contentType } = relations[path];
    const ids = get(`metadata.${path}`, data) || [];
    const getItem = contentType ? createGetContentItem(contentType) : getItemById;

    const items = ids.map((id) => getItem(state, id)).filter((relatedItem) => !!relatedItem) || [];

    related = set(setPath, items, related);
  }

  return related;
}

// Module Exports
export { getRelatedContentItems, getRelatedContentItemsByItem, getPostRelationsMap };
